// Pricing.jsx - Página de Planes y Precios (Para cumplir requisitos de Culqi)
import React from 'react';
import PricingPlans from '../components/PricingPlans';

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Header */}
      <header className="bg-white dark:bg-gray-800 shadow">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                MediExamPro
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                Plataforma de preparación para el residentado médico
              </p>
            </div>
            <nav className="flex gap-6">
              <a href="/" className="text-gray-700 dark:text-gray-300 hover:text-blue-600">
                Inicio
              </a>
              <a href="/pricing" className="text-blue-600 font-semibold">
                Planes
              </a>
              <a href="/contact" className="text-gray-700 dark:text-gray-300 hover:text-blue-600">
                Contacto
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Pricing Component */}
      <PricingPlans 
        currentPlan="free"
        onSelectPlan={(plan) => {
          console.log('Plan seleccionado:', plan);
          // Aquí se procesaría el pago con Culqi
        }}
      />

      {/* Features Section */}
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-center text-gray-900 dark:text-white mb-12">
            ¿Por qué elegir MediExamPro?
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-100 dark:bg-blue-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📚</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                +1,200 Preguntas
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Base de datos actualizada constantemente con preguntas de exámenes reales
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 dark:bg-green-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">🎯</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Análisis Predictivo
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                IA que analiza tu rendimiento y predice áreas de mejora
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-purple-100 dark:bg-purple-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📊</span>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                Estadísticas Detalladas
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Seguimiento completo de tu progreso por especialidad
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-8">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h4 className="font-bold mb-4">MediExamPro</h4>
              <p className="text-sm text-gray-400">
                La mejor plataforma de preparación para el residentado médico en Perú.
              </p>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Enlaces</h4>
              <ul className="text-sm space-y-2">
                <li><a href="/" className="text-gray-400 hover:text-white">Inicio</a></li>
                <li><a href="/pricing" className="text-gray-400 hover:text-white">Planes y Precios</a></li>
                <li><a href="/terms" className="text-gray-400 hover:text-white">Términos y Condiciones</a></li>
                <li><a href="/privacy" className="text-gray-400 hover:text-white">Política de Privacidad</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Contacto</h4>
              <ul className="text-sm space-y-2 text-gray-400">
                <li>Email: alexisgc90@gmail.com</li>
                <li>WhatsApp: +51 997 268 543</li>
                <li>Teléfono: +51 964 088 671</li>
                <li>Chiclayo, Perú</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-bold mb-4">Métodos de Pago</h4>
              <div className="flex gap-2">
                <span className="text-2xl">💳</span>
                <span className="text-2xl">📱</span>
              </div>
              <p className="text-sm text-gray-400 mt-2">
                Aceptamos Visa, Mastercard, Yape y Plin
              </p>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>© 2024 MediExamPro. Todos los derechos reservados.</p>
            <p className="mt-2">RUC: 10709315302 | Razón Social: GARCIA CASUSOL CESAR ALEXIS</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PricingPage;